import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';
import { BRAND } from '../data/mock';

const col = (title, links) => (
  <div>
    <div className="eyebrow text-[#c3a66d] mb-5">{title}</div>
    <ul className="space-y-3">{links.map((l) => (
      <li key={l.label}><Link to={l.path} className="text-[#d8d0bf] hover:text-[#ffeabf] text-sm transition-colors">{l.label}</Link></li>
    ))}</ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-[#053e49] text-[#faf4ea] pt-20 pb-10 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{backgroundImage:'radial-gradient(circle at 20% 20%, #c3a66d, transparent 50%), radial-gradient(circle at 80% 80%, #c3a66d, transparent 60%)'}} />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-5 gap-12 pb-14 border-b border-[#0b5260]">
          <div className="lg:col-span-2 max-w-sm">
            <Logo dark size="lg" />
            <p className="font-serif italic text-2xl mt-6 text-[#ffeabf]">Your Wedding. Anywhere in the World.</p>
            <p className="text-[#a8b7bb] text-sm mt-6 leading-relaxed">Destination weddings designed, planned, and delivered by one trusted team — from the first conversation to the final farewell.</p>
            <div className="flex gap-3 mt-7">
              {[
                { Icon: Instagram, label: 'Instagram' },
                { Icon: Youtube, label: 'YouTube' },
                { Icon: Linkedin, label: 'LinkedIn' },
              ].map(({ Icon, label }) => (
                <a key={label} href="#" className="w-10 h-10 border border-[#1a5c6b] hover:border-[#c3a66d] hover:text-[#c3a66d] flex items-center justify-center transition-colors" aria-label={label}><Icon size={16} /></a>
              ))}
            </div>
          </div>
          {col('Weddings', [
            {label:'Destination Weddings', path:'/destinations'},
            {label:'Wedding Services', path:'/services'},
            {label:'Sunday Mirror Certified', path:'/certified'},
            {label:'Guest Experience', path:'/services'},
            {label:'Wedding Planning', path:'/plan'},
          ])}
          {col('Explore', [
            {label:'Destinations', path:'/destinations'},
            {label:'Real Weddings', path:'/real-weddings'},
            {label:'Journal', path:'/journal'},
            {label:'Mirror AI', path:'/mirror-ai'},
            {label:'About Sunday Mirror', path:'/about'},
          ])}
          <div>
            <div className="eyebrow text-[#c3a66d] mb-5">Contact</div>
            <ul className="space-y-4 text-sm text-[#d8d0bf]">
              <li className="flex gap-3"><MapPin size={16} className="text-[#c3a66d] shrink-0 mt-0.5" /><span>{BRAND.address}</span></li>
              <li className="flex gap-3 items-center"><Phone size={16} className="text-[#c3a66d] shrink-0" /><a href={`tel:${BRAND.phone}`} className="hover:text-[#ffeabf]">{BRAND.phone}</a></li>
              <li className="flex gap-3 items-center"><Mail size={16} className="text-[#c3a66d] shrink-0" /><a href={`mailto:${BRAND.email}`} className="hover:text-[#ffeabf]">{BRAND.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 pt-8 text-xs text-[#8a9ba0]">
          <div className="flex gap-6">
            <span>© {new Date().getFullYear()} Sunday Mirror. All rights reserved.</span>
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#ffeabf]">Terms</a>
            <a href="#" className="hover:text-[#ffeabf]">Privacy</a>
            <a href="#" className="hover:text-[#ffeabf]">Careers</a>
            <a href="#" className="hover:text-[#ffeabf]">Become a Professional</a>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="font-serif italic text-3xl md:text-5xl text-[#ffeabf]/90">Anywhere I Do.</p>
          <p className="eyebrow text-[#c3a66d] mt-3">by Sunday Mirror</p>
        </div>
      </div>
    </footer>
  );
}
